import { ReactComponent as Photo_CV } from '../../assets/photo-cv.svg'
import { Card, Grid, Spacer, Text, Link, useMediaQuery } from '@geist-ui/react'

export const CV = () => {
  const isXs = useMediaQuery('xs')
  const isMdUp = useMediaQuery('md', { match: 'up' })

  const headerFontSize = isMdUp ? '50px' : '30px'
  const titleFontSize = isMdUp ? '30px' : '20px'
  const subtitleFontSize = isMdUp ? '20px' : '15px'

  const email = 'mailto:nora.gallia@gmail.com'
  const emailUrl = 'mailto:' + email

  const instagram = '@noraconlaenne'
  const instagramUrl = 'https://www.instagram.com/noraconlaenne/'

  const programs = [
    'Adobe Suite (Ps, Ai, Id)',
    'Rhinoceros 3D',
    'Procreate',
    'Canva',
    'Figma',
  ]

  return (
    <Grid.Container gap={0} justify='center'>
      {/* Type header */}
      <Grid style={{ margin: 0 }} xs={24} justify='center'>
        <Text style={{ margin: 0 }} className='lato-light' font={headerFontSize}>CURRICULUM VITAE</Text>
      </Grid>

      {/* Title */}
      <Grid style={{ margin: 0 }} xs={24} justify='center'>
        <Text style={{ margin: 0 }} className='lato-light' font={titleFontSize}>NORA GALLIA</Text>
      </Grid>

      {/* CV photo (when mobile view) */}
      {
        isXs && (
          <Grid style={{ marginTop: 30 }} xs={24} justify='center'>
            <Photo_CV style={{ height: '90%', maxHeight: '50vh' }} />
          </Grid>
        )
      }

      {/* Biography & Programmi */}
      <Grid xs={24} md={8} style={{ width: '100%', padding: '30px', paddingBottom: 0 }}>
        <Grid.Container gap={2} justify='space-between'>

          {/* Biography */}
          <Grid xs={24} justify='center'>
            <Card width={100} style={{ borderRadius: '20px' }}>
              <Card.Content>
                <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>BIOGRAPHY</Text>

                <Text style={{ marginBottom: '0px' }} className='lato-light ' font={subtitleFontSize}>NORA GALLIA</Text>
                <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline'>{`09 Marzo 1993\nPIVA 02626150995`}</Text>

                <Text style={{ marginBottom: '0px' }} className='lato-light' font={subtitleFontSize}>KEEP IN TOUCH</Text>
                <Grid.Container gap={0}>
                  <Grid xs={24} justify='flex-start'>
                    <Link href={emailUrl} style={{ marginTop: '0px', marginBottom: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline' target='_blank' rel='noopener noreferrer'>
                      {email}
                    </Link>
                  </Grid>
                  <Grid xs={24} justify='flex-start'>
                    <Link href={instagramUrl} style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline' target='_blank' rel='noopener noreferrer'>
                      {instagram}
                    </Link>
                  </Grid>
                </Grid.Container>
              </Card.Content>
            </Card>
          </Grid>

          {/* Programmi */}
          <Grid xs={24} justify='center'>
            <Card width={100} style={{ borderRadius: '20px' }}>
              <Card.Content>
                <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>PROGRAMMI</Text>

                <Grid.Container style={{ borderLeft: '1px solid black', paddingLeft: '10px' }}>
                  {
                    programs.map((p, index) => (
                      <Grid key={index} style={{ margin: 0 }} xs={24} justify='flex-start'>
                        <Text style={{ margin: 0 }} className='lato-light'>{p}</Text>
                      </Grid>
                    ))
                  }
                </Grid.Container>
              </Card.Content>
            </Card>
          </Grid>

        </Grid.Container>
      </Grid>

      {/* Formazione */}
      {/* TODO better newlines */}
      <Grid xs={24} md={8} style={{ width: '100%', padding: '30px', paddingTop: 0, paddingBottom: 0 }}>
        <Card width={100} style={{ border: 0 }}>
          <Card.Content>
            <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>FORMAZIONE</Text>

            <Text style={{ marginBottom: '0px' }} className='lato-light ' font={subtitleFontSize}>FIGMA ACADEMY</Text>
            <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline'>{`Grafigata Academy 2024`}</Text>

            <Text style={{ marginBottom: '0px' }} className='lato-light ' font={subtitleFontSize}>CORSO DI FUMETTO</Text>
            <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline'>{`Arena del Fumetto - Officina dell'arte DLF, 3\n\nBologna Ottobre 2022 / ad oggi`}</Text>

            <Text style={{ marginBottom: '0px' }} className='lato-light ' font={subtitleFontSize}>MASTER DI PRIMO LIVELLO</Text>
            <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline'>{`Illustrazione Creativa - 8/10 Bau - Centro universitario de disenyo de Barcelona (Spain)\n\nSettembre 2018 / Giugno 2019`}</Text>

            <Text style={{ marginBottom: '0px' }} className='lato-light ' font={subtitleFontSize}>LAUREA TRIENNALE</Text>
            <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline'>{`Design del Prodotto e della Nautica - 110/110 Università degli studi di Genova\n\nOttobre 2013 / Ottobre 2016`}</Text>

            <Text style={{ marginBottom: '0px' }} className='lato-light ' font={subtitleFontSize}>DIPLOMA DI MATURITÀ SCIENTIFICA</Text>
            <Text style={{ marginTop: '0px', borderLeft: '1px solid black', paddingLeft: '10px' }} className='lato-light newline'>{`Liceo Classico, Scientifico e Paritario Vittorino Bernini - 80/100\n\nLuglio 2013`}</Text>
          </Card.Content>
        </Card>
      </Grid>


      <Grid xs={24} md={8} style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={2} justify='space-between'>

          {/* CV photo (when non-mobile view) */}
          {
            !isXs && (
              <Grid xs={24} justify='center'>
                <Photo_CV style={{ height: '90%', maxHeight: '50vh' }} />
              </Grid>
            )
          }

          {/* Lingue & Certificazioni */}
          <Grid xs={24} justify='center' style={{ paddingTop: 0 }}>
            <Card width={100} style={{ borderRadius: '20px' }}>
              <Card.Content>
                <Text style={{ marginBottom: '10px' }} className='lato-light' font={titleFontSize}>LINGUE & CERTIFICAZIONI</Text>
                <Grid.Container style={{ borderLeft: '1px solid black', paddingLeft: '10px' }}>
                  <Grid style={{ margin: 0, marginBottom: '10px' }} xs={24} justify='flex-start'>
                    <Text style={{ margin: 0 }} className='lato-light newline'>{`Castellano B2, “CFA La Pau, Educaciò d'adults”\n(Barcelona, 2019)`}</Text>
                  </Grid>
                  <Grid style={{ margin: 0 }} xs={24} justify='flex-start'>
                    <Text style={{ margin: 0 }} className='lato-light newline'>{`English B1, “Cambridge Seminars College”\n(Cambridge, 2017)`}</Text>
                  </Grid>
                </Grid.Container>
              </Card.Content>
            </Card>
          </Grid>

        </Grid.Container>
      </Grid>

      <Spacer h={10} />
    </Grid.Container>
  )
}
